import { render, staticRenderFns } from "./brands.vue?vue&type=template&id=273b8cae&scoped=true"
import script from "./brands.vue?vue&type=script&lang=js"
export * from "./brands.vue?vue&type=script&lang=js"
import style0 from "./brands.vue?vue&type=style&index=0&id=273b8cae&prod&scoped=true&lang=css"
import style1 from "./brands.vue?vue&type=style&index=1&id=273b8cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273b8cae",
  null
  
)

export default component.exports